import { axios } from "@Root/API";

export const getPostGrads = params => {
  return axios.get("post-grads", { params });
};
